import React from 'react';
import css from './css.module.less';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import ProductTable from 'src/pages/StoreVoucher/Detail/Components/SalesChannelProductTable';
import { get } from 'lodash';
import { Form } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;

const FreeItem = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { salesChannelName, allSalesChannels, freeItemName, disabled } = props;
  return (
    <SectionWrapper
      containerClassName={css.container}
      title={getI18n('voucher.storeVoucherDetail.freeItems')}
      subtitle={getI18n('voucher.storeVoucherDetail.freeItemsSubtitle')}>
      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, salesChannelName);
          const cV = get(c, salesChannelName);
          return pV !== cV;
        }}>
        {({ getFieldValue }) => {
          const salesChannels = getFieldValue(salesChannelName) || [];
          if (salesChannels.length === 0) {
            return (
              <div className={css.noData}>
                {getI18n('voucher.storeVoucherDetail.selectsaleschannelfirst')}
              </div>
            );
          }
          return salesChannels.map((uuid) => {
            return (
              <Section key={uuid} bottomBorder className={css.section}>
                <div className={css.title}>{allSalesChannels[uuid]}</div>
                <Item
                  name={[...freeItemName, uuid]}
                  rules={[
                    {
                      validator: async (x, value) => {
                        if ((value || []).length < 1) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'general.advancedFilters.commonRadioMulSelect.selectItem',
                              ),
                            ),
                          );
                        }
                      },
                    },
                  ]}>
                  <ProductTable
                    disabled={disabled}
                    salesChannelUuid={uuid}
                    tableId={`${uuid}StoreVoucherFreeItemProducts`}
                    disabledProducts={[]}
                  />
                </Item>
              </Section>
            );
          });
        }}
      </Item>
    </SectionWrapper>
  );
};
export default FreeItem;
